module.exports = __webpack_public_path__ + "static/media/messageClassifier.cc080e03.webp";